/*
 *
 * AttendanceControl actions
 *
 */

import {
  FLUSH_STATE_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL,
  LOAD_ATTENDANCECONTROL_SUCCESS,
  LOAD_ATTENDANCECONTROL_ERROR,
  CHANGE_ATTENDANCECONTROL,
  CHANGE_ATTENDANCECONTROL_SUCCESS,
  CHANGE_ATTENDANCECONTROL_ERROR,
} from './constants';

/**
 * Clearing the state for AttendanceControl
 */
export function flushStateAttendanceControl() {
  return {
    type: FLUSH_STATE_ATTENDANCECONTROL,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the AttendanceControl, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_ATTENDANCECONTROL
 */
export function loadAttendance(id) {
  return {
    type: LOAD_ATTENDANCECONTROL,
    id,
  };
}

/**
 * Dispatched when the loadAttendanceControl are loaded by the request saga
 *
 * @param  {array} variables true for AttendanceControl
 *
 * @return {array} An action object with a type of LOAD_ATTENDANCECONTROL_SUCCESS passing the variables
 */
export function loadAttendanceSuccess(attendanceData) {
  return {
    type: LOAD_ATTENDANCECONTROL_SUCCESS,
    attendanceData,
  };
}

/**
 * Dispatched when loading the loadAttendanceControl fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_ATTENDANCECONTROL_ERROR passing the error
 */
export function loadAttendanceError(error) {
  return {
    type: LOAD_ATTENDANCECONTROL_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the AttendanceControl, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_ATTENDANCECONTROL
*/
export function changeAttendance(attendanceData) {
  return {
    type: CHANGE_ATTENDANCECONTROL,
    attendanceData,
  };
} 

/**
 * Dispatched when the changeAttendanceControl are changed/updated by the request saga
 *
 * @param  {array} variables true for AttendanceControl
 *
 * @return {array} An action object with a type of CHANGE_ATTENDANCECONTROL_SUCCESS passing the variables
*/
export function changeAttendanceSuccess(attendanceData) {
  return {
    type: CHANGE_ATTENDANCECONTROL_SUCCESS,
    attendanceData,
  };
} 

/**
 * Dispatched when loading the changeAttendanceControl fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_ATTENDANCECONTROL_ERROR passing the error
*/
export function changeAttendanceError(errorChange) {
  return {
    type: CHANGE_ATTENDANCECONTROL_ERROR,
    errorChange,
  };
} 
